import { render, staticRenderFns } from "./CommentsItem.vue?vue&type=template&id=56eb428e&scoped=true&"
import script from "./CommentsItem.vue?vue&type=script&lang=js&"
export * from "./CommentsItem.vue?vue&type=script&lang=js&"
import style0 from "./CommentsItem.vue?vue&type=style&index=0&id=56eb428e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eb428e",
  null
  
)

export default component.exports